const answeredSurvey = {
    "sections":
        [{
            "questions": [{
                "description": "請問您是否願意曝光部分資訊，以利消費者聯絡呢？",
                "type": "scq",
                "options": ["是", "否"],
                "answer": "是",
                "questions": [{
                    "answer": {"elaboration": null, "value": "29414828"},
                    "description": "連絡電話",
                    "type": "oeq",
                    "options": [],
                    "questions": [],
                    "required": false,
                    "format": {"examples": [], "multiple": null, "fields": []},
                    "condition": "是",
                    "helperText": null
                }, {
                    "type": "oeq",
                    "answer": {"elaboration": null, "value": "48182913"},
                    "options": [],
                    "questions": [],
                    "required": false,
                    "condition": "是",
                    "helperText": null,
                    "format": {"examples": [], "multiple": null, "fields": []},
                    "description": "傳真"
                }, {
                    "type": "oeq",
                    "answer": {"elaboration": null, "value": "xinbeilin@leandev.io"},
                    "options": [],
                    "questions": [],
                    "format": {"examples": [], "multiple": null, "fields": []},
                    "required": false,
                    "condition": "是",
                    "helperText": null,
                    "description": "電子信箱"
                }, {"condition": "是", "description": "自有網站/FB", "type": "oeq", "required": false}, {
                    "condition": "是",
                    "description": "其他販售管道",
                    "type": "oeq",
                    "required": false
                }, {"condition": "是", "description": "作物販售-作物名稱", "type": "oeq", "required": false}, {
                    "condition": "是",
                    "description": "作物販售-販售期間",
                    "type": "oeq",
                    "required": false
                }, {"condition": "是", "description": "作物販售-年產量", "type": "oeq", "required": false}, {
                    "condition": "是",
                    "description": "是否能接受消費者訂購且獨自包裝出貨",
                    "type": "scq",
                    "options": ["是", "否"],
                    "required": false
                }, {"condition": "是", "description": "其他想公開訊息或注意事項", "type": "oeq", "required": false}]
            }]
        }]
}

export default answeredSurvey;